import { concatenar } from './concatenar.js'
import { imprimeSiContiene } from './imprimeSiContiene.js'
import { mayusculas } from './mayusculas.js'
import { concatenarArray } from './concatenarArray.js'
import { concatenarArraySi } from './concatenarArraySi.js'
import { existeEnArray } from './existeEnArray.js'
import { buscaEnArray } from './buscaEnArray.js'
import { tabla } from './tabla.js'
import { celda } from './celda.js'
import { fechaMostrar } from './fechaMostrar.js'

export const funcionesPersonalizadas = {
  concatenar,
  imprimeSiContiene,
  mayusculas,
  concatenarArray,
  concatenarArraySi,
  existeEnArray,
  buscaEnArray,
  tabla,
  celda,
  fechaMostrar,
}
